<div class="cockpit-content">
  <h1>{{card.title | translate}}</h1>
  <div  class="cockpit-view"> <!-- Cockpit -->
    <h2 translate>m2.sprint6.cockpit.card.chart.einfuehrungUndDownload.einfuehrung.title</h2>
    <p translate>m2.sprint6.cockpit.card.chart.einfuehrungUndDownload.einfuehrung.content1</p>
  </div>
  <div> <!-- Download -->
    <h2 translate>m2.sprint6.cockpit.card.chart.einfuehrungUndDownload.download.title</h2>
    <p translate>m2.sprint6.cockpit.card.chart.einfuehrungUndDownload.download.content1</p>
      <div style="margin-bottom: 5px">
        <span class="ob-nav-link" (click)="exportCockpit()" role="button" tabindex="0">
          <mat-icon svgIcon="file_excel" class="ob-icon remove-whitespace"></mat-icon>
          <span class="link-text" translate>m2.sprint6.cockpit.card.chart.einfuehrungUndDownload.exportAllTable-excel</span>
        </span>
      </div>
      <div>
        <span class="ob-nav-link" (click)="downloadExportDataList()" role="button" tabindex="0">
          <mat-icon svgIcon="file_excel" class="ob-icon remove-whitespace"></mat-icon>
          <span class="link-text" translate>m2.sprint6.cockpit.card.chart.einfuehrungUndDownload.exportDatenblattExcel-datei</span>
        </span>
    </div>
  </div>
</div>
